import type { SVGProps } from "react";
export interface PinIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PinIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PinIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.975 15.434a1.125 1.125 0 0 1 1.59 1.591l-3.77 3.77a1.125 1.125 0 0 1-1.59-1.59z"
      />
      <path
        fill={color}
        d="M12.413 2.599a3.225 3.225 0 0 1 4.316.22l4.451 4.452a3.225 3.225 0 0 1 .221 4.316l-.22.245-.443.442c-.403.403-.95.628-1.52.628h-.593l-1.895 1.894c.113 1.406.026 2.586-.353 3.681-.381 1.102-1.025 2.027-1.87 2.962-.786.868-2.064.886-2.901.204l-.161-.146-8.942-8.942c-.826-.826-.868-2.224.057-3.061l.35-.308c.82-.695 1.648-1.23 2.612-1.563 1.096-.38 2.275-.467 3.68-.355l1.896-1.894v-.593c0-.57.225-1.116.628-1.519l.442-.442zm.935 2.818c0 .57-.227 1.116-.63 1.519l-1.95 1.95a2.19 2.19 0 0 1-1.726.627c-1.222-.1-2.072-.01-2.784.237-.677.234-1.312.639-2.07 1.308l8.752 8.753c.67-.758 1.075-1.392 1.31-2.069.246-.712.337-1.562.237-2.785-.05-.619.16-1.258.627-1.725l1.95-1.95.157-.143a2.15 2.15 0 0 1 1.362-.487h.595l.411-.411.125-.154a.97.97 0 0 0 0-1.071l-.125-.154-4.451-4.451a.974.974 0 0 0-1.225-.125l-.154.125-.411.411z"
      />
    </svg>
  );
}
